import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import Subject from 'common/src/utils/pubsub/subject';
import {CLPromiseRef} from '../shared.types';

const enabledFlagsPromise: CLPromiseRef<Set<FeatureFlagKey>> = {
  current: null,
};

const enabledFlagsSubject = new Subject<Set<FeatureFlagKey> | null>(null);

const allFrontendFlags = new Set(Object.values(FeatureFlagKey));

export {enabledFlagsPromise, enabledFlagsSubject, allFrontendFlags};
